import { MysteryQuestionBankModel } from './../../shared/models/mystery-shopper';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ChannelModel } from '../../shared/models/channel';
import { GeographyModel, ExcelModel } from '../../shared/models/geography';
import { RegionModel } from '../../shared/models/region';
import { UserDetailModel, UserMobileUpdateModel, UpdateMobileModel } from '../../shared/models/User';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { GeographyProvider } from '../../shared/providers/geography.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { StateProvider } from '../../shared/providers/state.provider';

@Component({
  selector: 'app-mysteryshopper-question-bank',
  templateUrl: './mysteryshopper-question-bank.component.html',
  styleUrls: ['./mysteryshopper-question-bank.component.scss']
})
export class MysteryshopperQuestionBankComponent implements OnInit {

  page = 1;
  users: MysteryQuestionBankModel[];
  regions: RegionModel[];
  geography: GeographyModel[];
  channels: ChannelModel[];
  roles: any[];
  cities: any[];
  states: any[];
  tempOptionModel: any;
  excel: ExcelModel = new ExcelModel();
  excelFileName: string;
  StatesfilterByRegion: any[];
  getPaginationCount;
  /************/

  filteredDetails: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  constructor(private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private rolesProvider: RolesProvider,
    public toast: ToastClientService,
    private xlsx: XlsxService,
    public alertService: AlertService,
    private uploadFile: UploadZipService) {

    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        this.getAllUsers(this.page);
      }
    });
  }

  ngOnInit() {
    this.getAllUsers(this.page);
  }

  ngDoCheck() {

  }

  getAllUsers(pageNumber) {
    this.apiService
      .getHeaders(
        this.apiConfig.getAllMysteryQuestionBank +
        "?page=" +
        pageNumber
      )
      .subscribe(
        (res: any) => {
          this.getPaginationCount = res.headers.get(
            "X-Pagination-Total-Count"
          );
          this.users = res.body.data;
          if (this.users.length > 0) {
            this.users.forEach((item) => {
              if (item.status == 1) {
                item.statusString = "Active";
              } else {
                item.statusString = "Inactive";
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  /***********/

  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  uploadXlsx(eve) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.enableUploadDiv(this.excel);
        }
      },
      (reason) => { }
    );
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.importQuestionBankExcel,
      module: "Users",
      zip: "no",
      excelname: this.excelFileName,
    });
  }

  importAllUsers(data) {
    this.apiService.post(this.apiConfig.importQuestionBankExcel, data).subscribe(
      (res: any) => {
        this.toast.Success("Data imported Successfully");
        this.getAllUsers(this.page);
      },
      (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      }
    );
  }

  downloadExcel() {
    this.exportExcelService.exportMysteryQuestionBankExcel();
  }

  paginationClick(pageNumber) {
    this.getAllUsers(pageNumber);
    this.page = pageNumber;
  }

  userMobile: UserMobileUpdateModel[] = [];

  editRowUser(index, item: UserDetailModel) {
    item.isEdit = true;
    console.log(item);
  }


  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }


  changeStatus(item: MysteryQuestionBankModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateMysteryQuestionBank + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getAllUsers(this.page);
      });
  }

}
